import { fade } from '@material-ui/core/styles/colorManipulator';
export const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  table: {
    minWidth: 750
  },
  button: {
    margin: '1.5rem',
    float: 'right'
  },
  iconTrashActive: {
    color: '#ff513f',
    // height: '1rem'
  },
  iconTrashNotActive: {
    color: '#d0d0d0',
    // height: '1rem'
  },  
  customInput: {
    textAlign: 'left'
  }, 
  customInputValue: {
    textAlign: 'right'
  },
  textField: {
    textAlign: 'left',
  },
  customLastRow : {
    // paddingTop: '1.5rem',
    // paddingBottom: '1.5rem',
    padding: '1.5rem 40px 1.5rem 14px'
  },
  buttonUpdate: {
    padding : 0, 
    marginLeft: '1rem',
  },
  // Toolbar
  title: {
      fontSize: '1rem',
      fontWeight: '500'
  },
  rootToolbar: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
  },
  containerTitle: {
      flex: '0 0 auto', 
  },
  spacer: {
      flex: '1 1 100%',
  },
  actions: {
      color: theme.palette.text.secondary,
      flex: '0 0 auto',
  },
  customCell: {
      padding: '14px 40px 14px 16px'
  },
});
 
